'use strict';

require('./TradeGothicCn18');

require('./TradeGothicLight');

require('./TradeGothicBdCn20');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/fonts/TradeGothic/index.js
// module id = 721
// module chunks = 0